import { dateScalarFromYmdParts } from '../graphqlScalars';

/**
 * Trusted `DateScalar` for the first day of the **local** current month (wall-clock `Date`),
 * built via `dateScalarFromYmdParts`. Use for GraphQL `Date` variables such as range starts when the
 * product definition is “calendar month in user local time”.
 */
export const getStartOfMonthYmd = (): DateScalar => {
  const now = new Date();

  const currentYear = now.getFullYear();

  const currentMonth = now.getMonth() + 1;

  return dateScalarFromYmdParts(currentYear, currentMonth, 1);
};
